<template>
	<div class="messages">
		<div class="row">
			<div class="col-5 mb-4">
				<h1>{{ $t("messages") }}</h1>
			</div>
			<div class="col-7 d-lg-none mb-4">
				<button class="btn btn-secondary float-right mb-2 ml-2" @click="getMessages"><b-icon icon="arrow-clockwise"></b-icon></button>
				<router-link
					v-if="$UserSession.hasPriv('MESSAGES')"
					to="/messages/new"
					class="float-right btn btn-primary"
				><b-icon icon="pencil-square"></b-icon> {{
					$t("new")
				}}</router-link>
			</div>
			<div class="d-none d-lg-inline col-7">
				<button class="btn btn-secondary float-right mb-2 ml-2" @click="getMessages"><b-icon icon="arrow-clockwise"></b-icon></button>
				<router-link
					v-if="$UserSession.hasPriv('MESSAGES')"
					to="/messages/new"
					data-cy="send-messages-button"
					class="float-right btn btn-primary"
					><b-icon icon="pencil-square"></b-icon> {{
					$t("new")
				}}</router-link
				>
				<input
					type="search"
					:placeholder="$t('search-messages-ellipses')"
					class="block float-right mr-4 form-control inline w-auto"
					:value="searchTerm"
					@input="searchTerm = $event.target.value"
					@keyup="searchTermChange"
					@search="searchTermChange"
				/>
			</div>
			<div class="col-12 d-lg-none mb-4">
				<input
					type="search"
					:placeholder="$t('search-messages-ellipses')"
					class="block w-full form-control"
					:value="searchTerm"
					@input="searchTerm = $event.target.value"
					@keyup="searchTermChange"
					@search="searchTermChange"
				/>
			</div>
		</div>

		<InfiniteScroll
			type="Message"
			:dataUrl="`${$settings.APIBaseURL}/messages/list`"
			dataProperty="messages"
			class="inspector-list full-width"
			itemClass="inspector-list-item mighthaveunreadicon"
			@selectItem="selectMessage"
			ref="infinitescroll"
			:lookaheadPx="50"
			idProperty="message_id"
			:autoSelectId="$route.params.messageid"
			:noResultsText="$t('no-messages-found')"
			scrollElementId="main"
		/>

		<div class="inspector-list-detail active" v-if="selectedMessage" ref="selectedMessage">
			<div v-if="selectedMessage.seriousconcern == 1" class="alert alert-danger">
				<b-icon icon="exclamation-triangle"></b-icon>
				{{$t('serious-concern')}}
			</div>

			<a
				class="btn btn-light btn-xs float-right ml-3"
				v-on:click="closeView()"
				><b-icon icon="x" width="1em" height="1em"></b-icon>
			</a>
			<button class="btn btn-primary float-right" @click="reply" v-if="selectedMessage.thread_id">{{ $t('reply') }}</button>
			<template v-if="thread.length && showthread">
				<div v-for="(message, i) in thread" :key="i">
					<template v-if="message.message_id == selectedMessage.message_id">
						<h2>{{ getMessageDisplayName(message) }}</h2>
						<h3>{{ message.message_subject }}</h3>
					</template>
					<template v-else>
						<p class="mb-0 small"><strong>{{ getMessageDisplayName(message) }}</strong></p>
						<p class="mb-0 small"><strong class="text-muted">{{ message.message_subject }}</strong></p>
					</template>
					<p v-if="message.datetime" class="text-muted mb-0 small">{{ message.datetime }}</p>
					<div style="white-space: pre-wrap">{{ message.message_content }}</div>
					<hr />
				</div>
				<button class="btn btn-light mt-4 mr-2" @click="showthread=false">{{ $t('hide-thread') }}</button>
			</template>
			<template v-else>
				<h2>{{ selectedMessage.DisplayName }}</h2>
				<h3>{{ selectedMessage.message_subject }}</h3>
				<p v-if="selectedMessage.datetime">{{ selectedMessage.datetime }}</p>
				<div style="white-space: pre-wrap">{{ selectedMessage.message_content }}</div>
				<button class="btn btn-light mt-4 mr-2" v-if="thread.length > 1" @click="showthread=true">{{ $t('show-thread') }} ({{thread.length}})</button>
			</template>
			<button class="btn btn-primary mt-4" @click="reply" v-if="selectedMessage.thread_id">{{ $t('reply') }}</button>
		</div>
	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";

export default {
	components: {
		InfiniteScroll,
	},
	data() {
		return {
			selectedMessage: null,
			searchTerm: null,
			searchTimer: null,
			thread: [],
			showthread: false
		};
	},
	mounted() {
		this.getMessages();
	},
	methods: {
		reply() {
			this.$router.push({path:`/messages/new/${this.selectedMessage.thread_id}`, query: {replyto: this.selectedMessage.messageto_id}});
		},
		markAsRead(message) {
			message.message_seen = '1';
			this.$cfetch(`${this.$settings.APIBaseURL}/messages/read`, {
				method: "post",
				data: {
					id: message.message_id,
				},
			})
				.then((json) => {
					if (json.status === "SUCCESS") {
						message.message_seen = "1";
					}
				})
				.catch((error) => {
					this.$log.error.call(this, error);
				});
		},
		getThread() {
			this.showthread = false;
			this.$store.commit('showBlockingSpinner');
			this.$cfetch(`${this.$settings.APIBaseURL}/messages/getthread`, {
				method: "post",
				data: {
					thread_id: this.selectedMessage.thread_id,
				},
			})
			.then((json) => {
				this.$store.commit('hideBlockingSpinner');
				if (json.status === "SUCCESS") {
					this.thread = json.messages.reverse();
					for(let message of this.thread) {
						if (message.created) {
							var dateObj = this.$datetime.getDateObjectFromDateTimeField(
								message.created
							);
							if (dateObj) {
								message.datetime = this.$d(dateObj, "datetime");
							}
						}
					}
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		selectMessage(message) {
			this.thread = [];
			this.selectedMessage = message;
			if (message.message_seen == "0") {
				this.markAsRead(message);
			}
			if (this.selectedMessage.created) {
				var dateObj = this.$datetime.getDateObjectFromDateTimeField(
					this.selectedMessage.created
				);
				if (dateObj) {
					this.selectedMessage.datetime = this.$d(dateObj, "datetime");
				}
			}
			if(this.selectedMessage.thread_id) {
				this.getThread();
			}
			this.$nextTick(function() {
				this.$refs.selectedMessage.scroll({top:0});
			});
		},
		closeView() {
			this.selectedMessage = null;
		},
		getMessages() {
			const body = {};
			if (this.searchTerm) {
				body.q = this.searchTerm;
			}
			this.$refs.infinitescroll.getData("replace", body);
		},
		searchTermChange() {
			if (this.searchTimer) {
				clearTimeout(this.searchTimer);
			}
			this.searchTimer = setTimeout(() => {
				this.getMessages();
			}, 500);
		},
		getMessageDisplayName(message) {
			if(message.fromuser_id == this.$UserSession.getValue('id')) {
				return this.$t('me');
			}
			return message.DisplayName;
		}
	},
};
</script>
